"use strict";var $export=require("./_export");$export($export.P,"String",{repeat:require("./_string-repeat")});